import React, { useState } from "react";
import ReturnHeader from "../../components/returnHeader";
import {
  Present,
  arrowLeft,
  chemistry,
  commentDots,
  crypto,
  galochka,
  imagePlus,
  likeVideo,
  lock,
  maths,
  message,
  pen,
  player,
  plusCircle,
  qalpoq,
  trash,
  tutorIcons,
} from "../../assets";
import { Link } from "react-router-dom";
import { FileInput, Modal, VideoModal } from "../../components/Generic";
import { Rate } from "antd";
import AvatarImage from "./../../components/avatarImage";
import { fake } from "../../faker";
import Comments from "../../components/Comments";
const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [percent, setPercent] = useState(90);
  const [star, setStar] = useState();
  const [isVidModalOpen, setisVidModalOpen] = useState(false);
  const [isChildValueFalse, setIsChildValueFalse] = useState(false);
  

  // modal opener
  const openModal = (item) => {
    setIsModalOpen(item === "edit" && true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openVideoModal = () => {
    setVideoModalOpen(true);
  };
  const closeVideoModal = () => {
    setVideoModalOpen(false);
  };
  // Comment 
  const handleChildValueChange = (newValue) => {
    setIsChildValueFalse(newValue);
  };
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(setIsChildValueFalse);
  };
  const content = [
    {
      icon: plusCircle,
      text: "Video qo’shish",
      action: "add",
    },
    {
      icon: trash,
      text: "O’chirish",
      action: "delete",
    },
    {
      icon: pen,
      text: "Tahrirlash",
      action: "edit",
    },
  ];
  console.log(star, "nechta yulduz");
  const locked = false;
  const completed = true 
  return (
    <div>
      <ReturnHeader page={"To’plam"}>
        {content &&
          content.map((item) => (
            <Link
              to={item.path}
              onClick={() => openModal(item.action)}
              className="flex hover:bg-slate-100 cursor-pointer h-[26px] sm:h-[30px] justify-start gap-5 items-center	p-1.5	md:p-3"
            >
              <div>
                <img className="w-[12px] h-[12px]" src={item.icon} alt="" />
              </div>
              <div className="text-[13px] md:text-[16px]">{item.text}</div>
            </Link>
          ))}
      </ReturnHeader>
      <Modal isOpen={isModalOpen} onClose={closeModal} modalName={"Edit"}>
        <div className="flex justify-center">
          <div className="box-border text-[22px] font-medium border-b-[2px] w-[304px] border-gray-opacityGray border-solid flex flex-col  px-[20px] pb-[5px] pt-[7px] justify-center items-center">
            Matematika online kurslar
          </div>
        </div>
        <div className="flex justify-center">
          <FileInput>
            <div className="flex justify-center mt-[22px] items-center flex-col">
              <img
                className="cursor-pointer w-[35px] h-[35px] pb-[10px]"
                src={imagePlus}
                alt=""
              />
              <div className="cursor-pointer mb-[10px] text-blue-chatBlue text-[15px] font-sans font-medium">
                Set photo
              </div>
            </div>
          </FileInput>
        </div>
      </Modal>
      <section className="mt-[30px] flex gap-[18px] flex-wrap mx-[30px] jutify-center">
        <div className="h-[270px] relative flex jutify-center sm:h-[330px] w-[368px] sm:w-[500px] rounded-[30px] overflow-hidden">
          {locked && (
            <div className="absolute flex justify-center items-center w-full sm:w-[500px] overflow-hidden top-0 left-0 h-full">
              <div className="absolute w-full sm:w-full z-[5] top-0 left-0 h-full sm:h-full bg-gray-opacityGray opacity-40"></div>
              <div className="z-[10] flex justify-center flex-col gap-[17px] items-center relative">
                <div className="">
                  <img src={lock} alt="" />
                </div>
                <div className="text-[Poppins] cursor-pointer text-[12px] bg-blue-buttonBlue px-[15px] py-[5px] rounded-[2px] text-white">
                  Sotib olish
                </div>
              </div>
            </div>
          )}
          <div className="w-full h-full relative flex justify-center items-center bg-gradient-to-r from-[#4D90E9] to-[#A1C6FD]">
            <img className="w-full h-full" src={maths} alt="" />
            {locked || <img className="absolute" src={player} alt="" />}
          </div>
        </div>
        <section>
          <div className="flex justify-between w-full gap-[95px]">
            <div className="text-[28px] font-medium mt-[30px] ">
              Matematika online kurslar
            </div>
            <div onClick={openVideoModal} className="text-[14px] text-blue-chatBlue cursor-pointer whitespace-nowrap font-medium">
              View all
            </div>
          </div>
          <div className="bg-blue-progressBlue rounded-[50px] mt-[10px] relative overflow-hidden">
            <div
              style={{ width: `${locked ? '0' : percent}%` }}
              className={`absolute bg-blue-lightBlue z-0 rounded-[50px] h-[20px]`}
            ></div>
            <div className="flex justify-center items-center relative z-10">
              <div className="text-[13px] text-white font-medium">
                {locked ? '0' : percent}% completed
              </div>
            </div>
          </div>
          <div className="flex mt-[14px] gap-[20px] justify-between items-center">
            <div className="flex gap-[5px] items-center">
              <img src={likeVideo} alt="" />
              <span className="text-blue-likeBlue">0</span>
            </div>
            <div className="flex gap-[5px] items-center">
              <img src={crypto} alt="" />
              <span className="text-gray-lightlyGray">0</span>
            </div>
            <div className="flex gap-[5px] items-center">
              <img src={commentDots} alt="" />
              <span className="text-gray-lightlyGray">0</span>
            </div>
            <div className="sm:w-[200px] w-[160px] flex justify-end">
              {locked || <Rate onChange={(item) => setStar(item)} />}
            </div>
          </div>
          <div className="mt-[20px] flex flex-col gap-[15px]">
            <div className="flex gap-[10px] items-center">
              <div className="shadow-lessonShadow rounded-[18px] bg-white">
                <img className="p-[13px] sm:p-[17px]" src={qalpoq} alt="" />
              </div>
              <div>
                <div className="text-[16px] font-medium sm:text-[18px]">
                  Video uchun 15 soat
                </div>
                <div className="text-[12px] font-[400] text-gray-lessonGray sm:text-[16px]">
                  Mukamma tugatish uchun 15 soat ajrating
                </div>
              </div>
            </div>
            <div className="flex gap-[10px] items-center">
              <div className="shadow-lessonShadow rounded-[18px] bg-white">
                <img className="p-[13px] sm:p-[17px]" src={Present} alt="" />
              </div>
              <div>
                <div className="text-[16px] font-medium sm:text-[18px]">
                  10+ video
                </div>
                <div className="text-[12px] font-[400] text-gray-lessonGray sm:text-[16px]">
                  Qo’shimcha 10 ta darsliklar siz uchun
                </div>
              </div>
            </div>
          </div>

          <div className="h-[50px] mt-[15px] sm:h-[12px]">
            {locked || (
              <div
              onClick={openVidModal}
                className={`bg-white pl-[15px] py-[12px] rounded-[4px] sm:hidden text-[12px] font-medium text-[#999] shadow-lessonComShadow`}
              >
                Izoh qoldirish
              </div>
            )}
          </div>

          <div className="bg-[white] pl-[15px] py-[17px] rounded-[30px] flex gap-[28px] shadow-teacherShadow">
            <div>
              <AvatarImage style={`w-[95px] h-[95px]`} />
            </div>
            <div className="">
              <div className="flex items-center relative justify-between w-full">
                <div className="text-[16px] font-medium font-sans">
                  Teacher Name
                </div>
                <div className="absolute right-[-40px] sm:right-[-120px]">
                  {tutorIcons.dots}
                </div>
              </div>
              <div className="text-gray-lessonGray font-sans text-[12px]">
                Matematika O’qituvchisi
              </div>
              <div className="flex mt-[7px] items-center">
                <div>
                  <img className="w-[24px] h-[24px]" src={likeVideo} alt="" />
                </div>
                <div className="text-blue-likeBlue font-medium text-[12px] font-sans">
                  0
                </div>
              </div>
              <div className="flex gap-[5px] pt-[10px]">
                <Link to='/user' className="px-[5px] py-[3px] text-[10px] sm:text-[13px] text-gray-lightlyGray border-solid border-[0.5px] rounded-[6px] border-gray-lightlyGray">
                  Follow
                </Link>
                <Link to='/chat' className="px-[5px] py-[3px] text-[10px] sm:text-[13px] text-gray-lightlyGray border-solid border-[0.5px] rounded-[6px] border-gray-lightlyGray">
                  Message
                </Link>
                <Link to='/message' className="px-[5px] py-[3px] text-[10px] sm:text-[13px] text-gray-lightlyGray border-solid border-[0.5px] rounded-[6px] border-gray-lightlyGray">
                  Share
                </Link>
              </div>
            </div>
          </div>
        </section>
        <div className="sm:block hidden w-[1000px]">
        <div className="bg-[#FFFFFF] relative py-[20px] rounded-[20px] border-box shadow-lessonComShadow w-[full] color-[red]">
          <div className="mx-[50px] ">
          <input
            type="text"
            placeholder="Izoh qoldirish"
            className={`outline-none shadow-tabShadow bg-blue-inputBlue pl-[15px] py-[12px] rounded-[4px] w-full  max-w-[900px] text-[13px] font-medium text-[#999] `}
            />
            <button className="absolute  top-[27px] px-[10px] py-[3px] transition-all duration-400  active:opacity-[0.5] rounded-[50px] right-[70px] shadow-sendShadow">
              <img src={message} alt="" />
            </button>
            </div>
        <Comments handleChildValueChange={handleChildValueChange}/>
        </div>
        </div>
        {/* videos modal  */}
        
        <Modal galocka={true} childrenStyle={'h-[400px]'} isOpen={videoModalOpen} onClose={closeVideoModal} modalName={"Videos"}>
          <div className="flex flex-col gap-[15px] my-[20px] overflow-auto">
          {fake.map((item)=>(
            <div key={item.id} className="flex items-center px-[20px] ">
        <div className='flex justify-center relative mr-[9px] items-center rounded-[10px] w-[90px] h-[83px] sm:w-[160] overflow-hidden'>
                    <img className='h-full' src={chemistry} alt="no data" />
                </div>
                <div className="flex items-center justify-between sm:w-[270px] w-[210px]">

                    <div className="flex text-[14px] sm:text-[18px] font-notoSans font-[400]  sm: justify-start"> Matematika 1-dars</div>
                    <div className=" w-[50px] sm:w-[70px]"> 
                    {
                      completed &&
                      <div className="flex items-center gap-[6px]">
                      <div className="text-blue-chatBlue sm:text-[10px] text-[7px] font-notoSans">completed</div>
                      <div><img className="w-[7px] h-[5px]" src={galochka} alt="" /></div>
                      </div>
                    }
                    </div>
                </div>
          </div>
        ))}
        </div>
        </Modal>
        {/* <--------------------------------------------> */}
        {/* Comments */}
        <VideoModal style={`${true}`}  onClose={closeVidModal} comments={true}  isOpen={isVidModalOpen}>
                            <div>
                            <div className='flex justify-between items-center mt-[40px] ml-[40px]'>
                                <div className='z-50 relative' onClick={closeVidModal}><img src={arrowLeft} alt="" /></div>
                                <div className='text-[20px] font-medium'>Comments</div>
                                <div className='w-[50px]'></div>
                            </div>
                            <div className='overflow-x-auto sm:h-[400px] h-[100vh] pb-[100px]'> 
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            </div>
                            <input className='flex justify-center border-box mb-[100px]  w-full rounded-[100px] px-[32px] outline-none h-[50px] bg-gray-inputGray' placeholder='Add Comment'/>
                            <div className='fixed sm:hidden flex justify-center bg-[white] pt-[5px] h-[100px] w-full bottom-[-40px]'>
                            <input className=' border-box mb-[100px]  w-full rounded-[100px] px-[32px] outline-none h-[50px] bg-gray-inputGray' placeholder='Add Comment'/>
                            </div>
                            </div>
                </VideoModal>
        {/* <--------------------------------------------> */}
      </section>
    </div>
  );
};

export default About;
